import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@shared/config';
import { OD_BACKEND_ROUTES } from 'src/app/od-backend/config/od-backend.routes';
import {
  FileEntity,
  FileParams,
  FileByIdParams,
  FileByIdKey,
} from '@shared/models/file.model';
import { FileValidator } from '@shared/utils/file.validator';

@Injectable({
  providedIn: 'root',
})
export class FileUrlService {
  private readonly baseUrl = inject(APP_CONFIG).odBackendApiUrl;
  private readonly baseFilesUrl = `${this.baseUrl}${OD_BACKEND_ROUTES.files}`;

  public getFileUrl<E extends FileEntity>(params: FileParams<E>): string {
    if (this.isByFileIdParams(params)) {
      if (!params.fileId) return '';

      const base = `${this.baseFilesUrl}/${encodeURIComponent(params.fileId)}`;
      return this.buildUrl(base, params.content);
    }

    const error = FileValidator.validatePublicParams(params);
    if (error) {
      console.warn(error);
      return '';
    }

    const base = `${this.baseFilesUrl}/public/${encodeURIComponent(params.entity)}`;

    const queryParams = new URLSearchParams();
    if (params.branding) {
      queryParams.set('branding', params.branding);
    }
    if (params.role) {
      queryParams.set('role', params.role);
    }

    return this.buildUrl(base, params.content, queryParams);
  }

  private isByFileIdParams(params: FileParams<any>): params is FileByIdParams {
    return ('fileId' satisfies FileByIdKey) in params;
  }

  private buildUrl(
    base: string,
    content?: boolean,
    params?: URLSearchParams
  ): string {
    const path = content ? `${base}/content` : base;
    const url = new URL(path, this.baseUrl);

    if (params?.size) {
      url.search = params.toString();
    }

    return url.toString();
  }
}
